import { CommonModule } from '@angular/common'
import { AfterViewInit, Component, inject, OnInit } from '@angular/core'
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { select, Store } from '@ngrx/store'
import {
  selectError,
  selectLoading,
  selectShowThankYouMessage
} from '../../../../store/auth/auth.state'
import { register, resetThankYouMessage } from '../../../../store/auth/auth.actions'
import { ActivatedRoute, Router, RouterModule } from '@angular/router'
import { Actions } from '@ngrx/effects'
import { Observable } from 'rxjs'
import { eps } from '../../../../services/url.service'
import { environment } from '../../../../../environments/environment'
import { StrictEmailDirective } from '../../../../directives/strict-email.directive'
import { noSpacesValidator } from '../../../../validators/no-spaces.validators'
import { noLeadingTrailingSpaces } from '../../../../validators/no-leadingTraillingSpace.validators'
import { SharedModule } from '../../../../shared/shared.module'
import { Country } from '../../../../store/country/country.state'
import { CityCountryState } from '../../../../store/state/state.state'
import { selectAllCountries } from '../../../../store/country/country.selectors'
import { selectAllStates } from '../../../../store/state/state.selectors'

import { loadStates } from '../../../../store/state/state.actions'
import { loadCountries } from '../../../../store/country/country.actions'

@Component({
  selector: 'app-registration',
  imports: [
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    RouterModule,
    StrictEmailDirective,
    SharedModule
  ],
  templateUrl: './registration.component.html',
  styleUrl: './registration.component.scss'
})
export class RegistrationComponent implements OnInit {
  form: FormGroup
  eps = eps
  planId!: string
  // public token = ''
  // public id = ''
  // // public locationId: string = "762d6a45-1edb-4231-9147-aa98e02c6c32";
  currentYear: number
  errorMessage$
  isLoading$
  actions$ = inject(Actions)
  showThankYouMessage$
  countries$: Observable<Country[]>
  states$: Observable<CityCountryState[]>
  selectedCountryId = ''
  selectedStateId = ''
  selectedCountryName = ''
  showGstQuestion = false
  showGstInput = false
  hasGst = false
  mode: 'trial' | 'buy' = 'trial'

  constructor(
    private fb: FormBuilder,
    private sanitizer: DomSanitizer,
    private store: Store,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false
    const planId = this.route.snapshot.paramMap.get('id')
    if (planId) this.planId = planId
    this.mode = (this.route.snapshot.queryParamMap.get('mode') as any) || 'trial'

    // if (this.mode === 'buy') {
    //   console.log('Redirect to payment flow')
    // } else {
    //   console.log('Start free trial flow')
    // }
    this.currentYear = new Date().getFullYear()
    this.errorMessage$ = this.store.pipe(select(selectError))
    this.isLoading$ = this.store.pipe(select(selectLoading))
    this.form = this.fb.group({
      firstName: ['', [Validators.required, Validators.maxLength(50), noLeadingTrailingSpaces()]],
      lastName: ['', [Validators.required, Validators.maxLength(50), noLeadingTrailingSpaces()]],
      email: ['', [Validators.required, Validators.email, noLeadingTrailingSpaces()]],
      mobile: ['', [Validators.required, this.phoneNumberValidator(), noLeadingTrailingSpaces()]], // Custom validator
      businessName: [
        '',
        [Validators.required, Validators.maxLength(100), noLeadingTrailingSpaces()]
      ],
      planId: [this.planId, [Validators.required, noLeadingTrailingSpaces()]],
      country: [
        this.selectedCountryId !== null &&
        this.selectedCountryId !== undefined &&
        this.selectedCountryId !== '' &&
        Number.isFinite(Number(this.selectedCountryId)) &&
        Number(this.selectedCountryId) > 0
          ? Number(this.selectedCountryId)
          : null,
        [Validators.required]
      ],
      state: [
        this.selectedStateId !== null &&
        this.selectedStateId !== undefined &&
        this.selectedStateId !== '' &&
        Number.isFinite(Number(this.selectedStateId)) &&
        Number(this.selectedStateId) > 0
          ? Number(this.selectedStateId)
          : null,
        [Validators.required]
      ],
      // hasGst: [false],
      gstNumber: ['']
    })

    // this.actions$.pipe(ofType(registerSuccess)).subscribe(() => {
    //   this.isLoading = false
    //   this.form.reset()
    // })
    // this.actions$.pipe(ofType(registerFailure)).subscribe(() => {
    //   this.isLoading = false
    //   // this.form.reset()
    // })

    this.showThankYouMessage$ = this.store.pipe(select(selectShowThankYouMessage))
    this.countries$ = this.store.select(selectAllCountries)
    this.states$ = this.store.select(selectAllStates)
  }
  ngOnInit() {
    this.store.dispatch(loadCountries())
  }
  // // Method to handle form submission
  register() {
    if (this.form.valid) {
      // this.isLoading = true
      const payload = { ...this.form.value }

      // delete payload.country
      // delete payload.state
      delete payload.hasGst

      // this.store.dispatch(register(this.form.value))
      // this.store.dispatch(register(payload))
      this.store.dispatch(
        register({
          ...payload,
          mode: this.mode,
          country:
            Number.isFinite(Number(this.form.value.country)) && Number(this.form.value.country) > 0
              ? Number(this.form.value.country)
              : null,
          state:
            Number.isFinite(Number(this.form.value.state)) && Number(this.form.value.state) > 0
              ? Number(this.form.value.state)
              : null
        })
      )
    }
  }
  phoneNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const phoneNumber = control.value
      // This regex allows for a '+' followed by 1 to 3 digits (country code),
      // optionally followed by a space, and then 1 to 14 digits (the phone number).
      const valid = /^\+\d{1,3} ?\d{1,14}$/.test(phoneNumber)
      return valid ? null : { invalidPhoneNumber: true }
    }
  }
  getErrorMessage(controlName: string): string | null {
    const control = this.form.get(controlName)
    // console.log('control name', control)
    if (control && control.touched && control.invalid) {
      if (control.hasError('required')) {
        if (controlName === 'country') return 'Country is required'
        if (controlName === 'state') return 'State is required'
        return 'This field is required'
      }
      if (control.hasError('email')) {
        return 'Please enter a valid email address'
      }
      if (control.hasError('invalidPhoneNumber')) {
        return 'Invalid phone number format. Valid format ex.: +91 99xxxxxxxx'
      }
    }
    return null // No error
  }

  get copyrightText(): SafeHtml {
    const copyrightSymbol = '\u00A9' // Unicode for ©
    const text =
      this.currentYear === 2025
        ? `Copyright ${copyrightSymbol} 2025 - <a href="https://avrtechno.com" class="hover-a text-white">AVR Software Pvt. Ltd.</a>`
        : `Copyright ${copyrightSymbol} 2025 - ${this.currentYear} - <a href="https://avrtechno.com" class="hover-a text-white">AVR Software Pvt. Ltd.</a>`
    return this.sanitizer.bypassSecurityTrustHtml(text)
  }

  handleSignInClick(): void {
    this.store.dispatch(resetThankYouMessage())
  }

  // onCountrySelect(countryId: string): void {
  //   this.selectedCountryId = countryId
  //   this.store.dispatch(loadStates({ countryId }))
  // }

  onCountrySelect(countryId: any): void {
    this.store.dispatch(loadStates({ countryId }))

    // this.countries$.subscribe(countries => {
    //   const country = countries.find(c => c.id == countryId)

    //   // this.selectedCountryName = country?.name || ''

    //   // this.showGstQuestion = this.selectedCountryName.toLowerCase() === 'india'
    //   this.showGstQuestion = countryId == 101

    //   if (!this.showGstQuestion) {
    //     this.showGstInput = false
    //     this.form.patchValue({
    //       hasGst: '',
    //       gstNumber: ''
    //     })
    //   }
    // })
    this.showGstQuestion = countryId === 101

    if (!this.showGstQuestion) {
      this.showGstInput = false
      this.form.patchValue({
        // hasGst: false,
        gstNumber: ''
      })
    }
  }

  onCountryChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement
    const countryId = selectElement.value
    this.selectedCountryId = countryId
    this.store.dispatch(loadStates({ countryId }))
  }

  // onGstSelection(value: string): void {
  //   this.showGstInput = value === 'yes'

  //   const gstControl = this.form.get('gstNumber')

  //   if (value === 'yes') {
  //     gstControl?.setValidators([
  //       Validators.required,
  //       Validators.pattern(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/)
  //     ])
  //   } else {
  //     gstControl?.clearValidators()
  //     gstControl?.setValue('')
  //   }

  //   gstControl?.updateValueAndValidity()
  // }

  onGstToggle(): void {
    // const hasGst = this.form.get('hasGst')?.value

    this.showGstInput = this.hasGst

    const gstControl = this.form.get('gstNumber')

    if (this.hasGst) {
      gstControl?.setValidators([
        Validators.required,
        Validators.pattern(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/)
      ])
    } else {
      gstControl?.clearValidators()
      gstControl?.reset()
    }

    gstControl?.updateValueAndValidity()
  }

  // ngAfterViewInit() {
  //   document.body.innerHTML = '<h1 style="color:red">REGISTER LOADED</h1>'
  //   document.body.style.background = 'yellow'
  // }
}
